import React from "react";
import { FormattedMessage } from "react-intl";
import { ListGroup, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeleteModalComponent, StandardTableComponent, TableEditActionComponent, TableDeleteActionComponent } from "../../basics/table";
import Website from "../../../models/website/Website";
import { Application, CountryHelper, CheckPermissions, GeneralSettingsHelper } from "../../../helpers";
import UserRolesEnum from "../../../enums/UserRolesEnum";
import { EventOptionGroupRepository, WebsiteRepository } from "../../../repository";
import FormattedMessageString from "../../basics/FormattedMessageString";
import FormToastComponent from "../../basics/FormToastComponent";
import LoaderComponent from "../../basics/layout/LoaderComponent";
import ToolTipLink from "../../basics/ToolTipLink";
import OptionOverviewTreeComponent from "./OptionOverviewTreeComponent";

class OptionGroupOverviewTableComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rows: this.props.rows,
            website: null,
            isLoading: true,
            toggler: [],
            language: Application.tableLanguage()
        };

        this.canEdit = CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR) && !GeneralSettingsHelper.is();
    }

    componentDidMount() {
        WebsiteRepository.get(Website.get()).then(result => this.setState({ website: result, isLoading: false }));
    }

    params = () => this.props.parent.props.match.params;

    basePath = () => '/module/events/' + this.params().module + '/options/' + this.params().event;

    columns(language) {
        return [
            {
                dataField: 'id',
                hidden: true
            },
            {
                dataField: 'title',
                text: <FormattedMessageString id="CMS.Event.option.group.overview.table.title" />,
                sort: true,
                isDummyField: true,
                formatter: (_, row) => row.getContent(language)?.title
            },
            {
                dataField: 'type',
                text: <FormattedMessageString id="CMS.Event.option.group.overview.table.type" />,
                sort: true,
                formatter: (_, row) => <FormattedMessageString id={'CMS.Event.option.group.form.type.' + row.type} />
            },
            {
                dataField: 'required',
                text: <FormattedMessageString id="CMS.Event.option.group.overview.table.required" />,
                sort: true,
                formatter: (_, row) => <FormattedMessageString id={row.required ? 'CMS.Common.Yes' : 'CMS.Common.No'} />
            },
            {
                dataField: 'updated',
                text: <FormattedMessageString id="CMS.Event.option.overview.table.last_updated" />,
                isDummyField: true,
                sort: true,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    let dateA = rowA.getContent(language)?.updated_at;
                    let dateB = rowB.getContent(language)?.updated_at;

                    return order === 'desc' ? dateB - dateA : dateA - dateB;
                },
                formatter: (_, row) => {
                    let content = row.getContent(language);
                    if (!content) return null;

                    return (
                        <div className="updated_by">
                            {content.updated_at?.format('DD/MM/YYYY HH:mm:ss')}
                            {content.updated_by && (<><br /><span className="small-highlighted-text"><FormattedMessageString id="CMS.Pages.overview.table.updated_by" /> {content.updated_by}</span></>)}
                        </div>
                    );
                }
            },
            {
                dataField: 'actions',
                isDummyField: true,
                text: <FormattedMessage id="CMS.Table.actions" />,
                hidden: !CheckPermissions.role(this.props.user.roles, UserRolesEnum.EDITOR),
                sort: false,
                editable: false,
                headerStyle: () => ({ width: '15%' }),
                formatter: (_, row) => (
                    <div className="actions actions-end">
                        <ToolTipLink className="link mr-1 px-1 link-auto" to={this.basePath() + '/' + row.id + '/overview'} title="CMS.Event.option.group.overview.tooltip.options">
                            <FontAwesomeIcon icon={['fa', 'list']} className="mr-2" />
                            {row.options.length}
                        </ToolTipLink>
                        {this.canEdit && (
                            <TableEditActionComponent id={row.id} path={this.basePath() + '/edit/' + row.id + '/' + language} />
                        )}
                        {this.canEdit && (
                            <TableDeleteActionComponent row={row} parent={this} disabled={row.used} />
                        )}
                    </div>
                )
            }
        ];
    }

    updateData = () => EventOptionGroupRepository.all(this.params().event).then(rows => this.props.parent.setState({ rows: rows }));

    delete = (event, _row) => {
        if (_row.used) {
            FormToastComponent.errorTrans('CMS.Event.option.error.event_option_used');
            return this.setState({ showDeleteModal: false, deleteRow: null });
        }

        return EventOptionGroupRepository.delete({ id: _row.id, event: this.params().event })
            .then(() => this.setState({ rows: this.state.rows.filter(row => _row.id !== row.id), showDeleteModal: false, deleteRow: null }))
            .catch(() => FormToastComponent.errorTrans('CMS.Table.delete.error'));
    }

    toggle = (event) => {
        let target = event.target.closest('button');
        let index = target.attributes['data-index'].value;
        let viewType = target.attributes['data-view-type'].value;

        this.props.parent.setState({ reload: true }, () => {
            this.props.parent.setState({ reload: false }, () => {
                let toggler = this.state.toggler;
                toggler[index] = viewType;
                this.props.parent.table_ref.setState({ toggler: toggler, language: this.state.language });
            });
        });
    }

    table = (index, language) => (
        <div className="custom-data-table event-options">
            <StandardTableComponent keyField="id" data={this.state.rows} columns={this.columns(language)} search={false}
                title={this.props.title_id} type={this.props.type}
                custom={this.canEdit ? this.switch(index) : undefined}
                subRows={false}
                sort={{ dataField: 'sort_order', order: 'asc' }}
            />
            <DeleteModalComponent parent={this} customDeleteRowFunction={this.delete} customCloseModalFunction={() => this.setState({ showDeleteModal: false, deleteRow: null })} />
        </div>
    )

    tree = (index, language) => (
        <div className="custom-data-table event-options">
            <div className="table-wrapper">
                <div className="table-header">
                    <FormattedMessage id="CMS.Module.overview.tree.title" values={{ module: <FormattedMessageString id={this.props.title_id} /> }}>{(value) => <p>{value}</p>}</FormattedMessage>
                    {this.switch(index)}
                </div>
                <OptionOverviewTreeComponent data={this.state.rows} language={language}
                    onSave={tree => EventOptionGroupRepository.updateOrder(this.params().event, tree)}
                    onSaved={this.updateData} />
            </div>
        </div>
    )

    switch = (index) => (
        <div className="toggle-tree" data-toggle="buttons" data-index={index}>
            <button type="button" data-toggle="button" data-view-type={"table"} data-index={index}
                onClick={this.toggle}
                disabled={this.state.toggler[index] === "tree" ? null : 'disabled'}>
                <FontAwesomeIcon icon={['far', 'th']} />
            </button>
            <button type="button" data-toggle="button" data-view-type={"tree"} data-index={index}
                onClick={this.toggle}
                disabled={this.state.toggler[index] === "tree" ? 'disabled' : ''}>
                <FontAwesomeIcon icon={['far', 'list']} />
            </button>
        </div>
    );

    render() {
        if (this.state.isLoading || this.state.reload) return <LoaderComponent />;

        return (
            <div className="tab-tables">
                <Tab.Container id="list-group-language-event-option-groups"
                    defaultActiveKey={"#" + (this.state.website.languages[this.state.language] !== undefined ? this.state.website.languages[this.state.language].language : this.state.website.languages[0].language)}>
                    <ListGroup>
                        {this.state.website.languages.map((language, index) => (
                            <ListGroup.Item action href={"#" + language.language} key={index}
                                onClick={() => this.setState({ language: index }, () => Application.setTableLanguage(index))}>
                                {CountryHelper.getLanguages().find(({ value }) => value + "" === language.language + "").label}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                    <Tab.Content>
                        {this.state.website.languages.map((language, index) => (
                            <Tab.Pane eventKey={"#" + language.language} key={index}>
                                {this.state.toggler[index] === "tree"
                                    ? this.tree(index, language.language)
                                    : this.table(index, language.language)
                                }
                            </Tab.Pane>
                        ))}
                    </Tab.Content>
                </Tab.Container>
            </div>
        );
    }
}

export default OptionGroupOverviewTableComponent;
